// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SimilarStrollers__headline":"xw_a bic_vp bic_vh bic_xe bic_rg bic_tr bic_qx"};